import { render, staticRenderFns } from "./EventsContainer.vue?vue&type=template&id=44c23579&scoped=true&"
import script from "./EventsContainer.vue?vue&type=script&lang=js&"
export * from "./EventsContainer.vue?vue&type=script&lang=js&"
import style0 from "./EventsContainer.vue?vue&type=style&index=0&id=44c23579&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c23579",
  null
  
)

export default component.exports